import { render, staticRenderFns } from "./IHMForm.vue?vue&type=template&id=d6d5ce0e&"
import script from "./IHMForm.vue?vue&type=script&lang=js&"
export * from "./IHMForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QList,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QList,QItem,QItemSection,QItemLabel})
